import $ from 'domtastic'




/* TAB SWITCH
----------------------------------------------------------------------------------------------------*/

export default class TabSwitch {

    constructor($el) {
        this.$els = {
            ctn   : $el,
            items : $el.find('.tabSwitch__item'),
            links : $el.find('.tabSwitch__link'),
        }

        this.bindEvents()
    }


    bindEvents() {
        this.$els.links.on('click', (e) => {
            e.preventDefault()
            const { target } = e
            const $nextSection = $(target.getAttribute('href'))

            this.$els.items.removeClass('is-current')
            $(target.closest('.tabSwitch__item')).addClass('is-current')

            this.$els.links.forEach((l) => {
                $(l.getAttribute('href')).addClass('is-hidden')
            })

            $nextSection.removeClass('is-hidden')
        })
    }




    /* Handlers
    --------------------------------------------------------- */




    /* Actions
    --------------------------------------------------------- */




    /* Values
    --------------------------------------------------------- */

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



